import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { AuditIncluded, AuditMeta, AuditOptions, AuditSAttrProps } from '../types/audit.types'
import { GeneralResMock } from '../types/general.type'

export const useAudit = (arg?: AuditOptions) => {
  const id = arg?.id
  const page = arg?.page
  const pageCount = arg?.limit
  const sort_dir = arg?.sort_dir || 'desc'
  const sort_by = arg?.sort_by || 'created_at'
  const auditable_type = arg?.auditable_type
  const user_id = arg?.user_id
  const username = arg?.username
  const action = arg?.action
  let start_date = ''
  const capturedStartRaw = arg?.start_date
  if (capturedStartRaw && moment(capturedStartRaw, moment.ISO_8601, true).isValid()) {
    start_date = moment(capturedStartRaw).format('YYYY-MM-DD')
  }

  let end_date = ''
  const capturedEndRaw = arg?.end_date
  if (capturedEndRaw && moment(capturedEndRaw, moment.ISO_8601, true).isValid()) {
    end_date = moment(capturedEndRaw).format('YYYY-MM-DD')
  }

  const { data: audits, isLoading: auditsIsLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<AuditSAttrProps[], AuditIncluded[], AuditMeta>>(
        '/audits',
        {
          params: {
            ...(page && { 'page[number]': page }),
            ...(pageCount && { 'page[size]': pageCount }),
            ...(sort_dir && { sort_dir }),
            ...(sort_by && { sort_by }),
            ...(auditable_type && { auditable_type }),
            ...(user_id && { user_id }),
            ...(username && { username }),
            ...(action && { action }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date })
          }
        }
      )
      return data
    },
    queryKey: [
      'audits',
      {
        page,
        pageCount,
        sort_by,
        sort_dir,
        auditable_type,
        user_id,
        username,
        action,
        start_date,
        end_date
      }
    ]
  })

  const { data: singleAudit, isLoading: singleAuditIsLoading } = useQuery({
    enabled: !!id,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<AuditSAttrProps, AuditIncluded[]>>(`/audits/${id}`)
      return data
    },
    queryKey: ['audits', { id }]
  })

  return {
    included: audits?.included,
    auditsIsLoading,
    audits: audits?.data,
    auditMeta: audits?.meta,
    auditsPagination: audits?.meta?.pagination,
    singleIncluded: singleAudit?.included,
    singleAudit: singleAudit?.data,
    singleAuditIsLoading
  }
}

export default useAudit
